<ng-container *ngTemplateOutlet="footerContent" />
